// extracted by mini-css-extract-plugin
export default {"overlay":"iC-z","bodyOpen":"jC-z","content":"kC-z","header":"lC-z","close":"mC-z","closeNoHeading":"nC-z"};